import { useEffect, useState } from 'react';
import { AbsenceReportApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { TopEmployeesByRemainingDaysDto } from '../../../commonTypes/reports.types';

export interface IGetTopLeaveBalanceQuery {
    leaveType: string;
    teamId?: string;
    search?: string;
    sort: 'remainingDesc' | 'remainingAsc';
    page: number;
    size: number;
}

const useHttpGetTopLeaveBalance = (query: IGetTopLeaveBalanceQuery) => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);
    const [data, setData] = useState<TopEmployeesByRemainingDaysDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [isReady, setIsReady] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (!query.leaveType) return;

        setIsReady(false);
        const { exec, abort } = absenceReportApi.getTopEmployeeLeaveBalance({
            query,
            onSuccess: res => {
                setData(res.body.content);
                setTotal(res.body.totalElements);
                setIsError(false);
            },
            onError: () => setIsError(true),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [query.leaveType, query.teamId, query.search, query.sort, query.page, query.size]);

    return { data, total, isReady, isError };
};

export default useHttpGetTopLeaveBalance;
